module.exports = __webpack_public_path__ + "img/wallpaper.0a97ab6c.png";